export default {
  '200': '',
  '401': {
    '001': 'errors.authFail',
    '002': 'errors.authKickOut',
    '003': 'errors.authContractFail'
  },
  '500': {
    '001': 'errors.serverFail'
  },
  '504': {
    '001': 'errors.serverFail'
  }
}
